import React from "react";

function ContactHRIcon() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="44"
			height="44"
			fill="none"
			viewBox="0 0 44 44"
		>
			<circle cx="20" cy="20" r="20" fill="#F4F2F6" />
			<mask
				id="mask0_2317_173704"
				style={{ maskType: "alpha" }}
				width="40"
				height="40"
				x="0"
				y="0"
				maskUnits="userSpaceOnUse"
			>
				<circle cx="20" cy="20" r="20" fill="#F4F2F6" />
			</mask>
			<g mask="url(#mask0_2317_173704)">
				<path
					fill="#190A28"
					d="M20.225 5.809c-6.368 0-8.375 4.302-8.375 7.113 0 2.81 1.606 6.367 1.606 6.367H26.993s1.607-3.557 1.607-6.367c.057-2.811-2.008-7.113-8.375-7.113z"
				/>
				<path
					fill="#FAFBFC"
					fillRule="evenodd"
					d="M13.816 20.098a2.301 2.301 0 01-2.77-2.245c0-1.205 1.033-2.294 2.295-2.294.039 0 .076 0 .114.002v-.977c0-3.786 3.04-6.826 6.769-6.826 3.728 0 6.769 3.04 6.769 6.769v1.046c.057-.007.114-.012.173-.014a2.301 2.301 0 012.294 2.294 2.301 2.301 0 01-2.851 2.226 6.758 6.758 0 01-1.114 2.018 6.741 6.741 0 01-2.401 1.898v3.61l-2.868 2.868-2.869-2.868V24.01a6.781 6.781 0 01-1.375-.854 6.736 6.736 0 01-2.166-3.06z"
					clipRule="evenodd"
				/>
				<path
					fill="#4D3951"
					fillOpacity="0.05"
					fillRule="evenodd"
					d="M13.816 20.098a2.301 2.301 0 01-2.77-2.245c0-1.205 1.033-2.294 2.295-2.294.039 0 .076 0 .114.002v-.977c0-3.786 3.04-6.826 6.769-6.826 3.728 0 6.769 3.04 6.769 6.769v1.046c.057-.007.114-.012.173-.014a2.301 2.301 0 012.294 2.294 2.301 2.301 0 01-2.851 2.226 6.758 6.758 0 01-1.114 2.018 6.741 6.741 0 01-2.401 1.898v3.61l-2.868 2.868-2.869-2.868V24.01a6.781 6.781 0 01-1.375-.854 6.736 6.736 0 01-2.166-3.06z"
					clipRule="evenodd"
				/>
				<path
					fill="#190A28"
					d="M13.816 20.098l.709-.246-.217-.625-.648.137.156.734zm-.36-4.537l-.038.75.787.038v-.788h-.75zm13.537.012h-.75v.843l.837-.099-.087-.744zm.173-.014v-.75h-.035l.035.75zm-.557 4.52l.183-.727-.668-.168-.224.65.709.245zm-1.114 2.018l-.585-.468.585.468zm-2.401 1.898l-.32-.679-.43.203v.476h.75zm0 3.61l.53.53.22-.22v-.31h-.75zm-2.868 2.868l-.53.53.53.53.53-.53-.53-.53zm-2.869-2.868h-.75v.31l.22.22.53-.53zm0-3.594h.75v-.478l-.433-.202-.317.68zm-1.375-.854l-.469.586.469-.586zm-2.64-2.26c.215 0 .426-.022.63-.066l-.312-1.467c-.102.022-.209.034-.319.034v1.5zm-3.045-3.044a3.051 3.051 0 003.044 3.045v-1.5a1.551 1.551 0 01-1.544-1.545h-1.5zm3.044-3.044c-1.688 0-3.044 1.437-3.044 3.044h1.5c0-.802.709-1.544 1.544-1.544v-1.5zm.151.003l-.15-.003v1.5c.025 0 .05 0 .076.002l.074-1.499zm-.787-.228v.977h1.5v-.977h-1.5zm7.519-7.576c-4.147 0-7.519 3.38-7.519 7.576h1.5c0-3.376 2.709-6.076 6.019-6.076v-1.5zm7.519 7.519c0-4.143-3.376-7.52-7.52-7.52v1.5c3.315 0 6.02 2.705 6.02 6.02h1.5zm0 1.046v-1.046h-1.5v1.046h1.5zm-.611-.764c-.077.004-.152.01-.227.019l.175 1.49c.04-.005.08-.008.12-.01l-.069-1.499zm3.078 3.044a3.051 3.051 0 00-3.044-3.044v1.5c.847 0 1.544.696 1.544 1.544h1.5zm-3.044 3.045a3.051 3.051 0 003.044-3.045h-1.5c0 .848-.697 1.545-1.544 1.545v1.5zm-.74-.092c.238.06.485.092.74.092v-1.5c-.13 0-.255-.017-.374-.046l-.366 1.454zm-.345 1.76c.552-.69.963-1.45 1.237-2.242l-1.418-.49a6.006 6.006 0 01-.99 1.795l1.171.937zm-2.668 2.108a7.491 7.491 0 002.668-2.108l-1.171-.937a5.99 5.99 0 01-2.135 1.687l.638 1.358zm.43 2.93v-3.609h-1.5v3.61h1.5zm-3.087 3.4l2.868-2.87-1.06-1.06-2.869 2.868 1.06 1.061zm-3.929-2.87l2.868 2.87 1.06-1.062-2.867-2.868-1.06 1.06zm-.22-4.123v3.594h1.5V24.01h-1.5zm-1.094-.268c.48.383.993.699 1.528.948l.633-1.36a6.038 6.038 0 01-1.224-.76l-.937 1.172zm-2.405-3.399a7.487 7.487 0 002.405 3.399l.937-1.172a5.987 5.987 0 01-1.925-2.72l-1.417.493z"
				/>
				<path
					fill="#190A28"
					d="M11.85 13.208s4.015 1.549 8.374-3.5c2.467 4.36 8.375 3.73 8.375 3.73s.918-8.376-8.375-8.376-8.375 8.146-8.375 8.146z"
				/>
				<path
					fill="#6750A4"
					stroke="#190A28"
					strokeWidth="1.5"
					d="M6.25 34.374S11.25 40 20.312 40c7.813 0 13.75-5.625 13.75-5.625 0-3.728-2.996-6.769-6.725-6.769H13.168c-3.786 0-6.918 3.04-6.918 6.77z"
				/>
				<path
					fill="#190A28"
					fillOpacity="0.7"
					d="M16.666 23.334v1.667c3.6-.238 5-1.667 5-1.667h-5z"
				/>
				<path
					fill="#fff"
					d="M23.038 28.003l-1.676 3.199 1.745 9.326a.14.14 0 01-.067.147l-2.656 1.574a.14.14 0 01-.143 0l-2.657-1.575a.14.14 0 01-.067-.145l1.65-9.327L17.58 28a.138.138 0 01.099-.199c.463-.085 1.73-.302 2.633-.302.9 0 2.16.216 2.628.302.093.017.14.118.097.201z"
				/>
				<path
					stroke="#190A28"
					strokeWidth="1.5"
					d="M21.362 31.202l1.676-3.199a.138.138 0 00-.097-.201c-.467-.086-1.728-.302-2.628-.302-.904 0-2.17.217-2.633.302a.138.138 0 00-.099.199l1.586 3.2m2.195 0l1.745 9.327a.14.14 0 01-.067.147l-2.656 1.574a.14.14 0 01-.143 0l-2.657-1.575a.14.14 0 01-.067-.145l1.65-9.327m2.195 0h-2.195"
				/>
			</g>
			<circle cx="34" cy="34" r="8.889" fill="#1F8268" />
			<path
				fill="#fff"
				d="M37.313 37.75c-.896 0-1.77-.2-2.62-.6a7.954 7.954 0 01-3.844-3.843 6.11 6.11 0 01-.599-2.62.424.424 0 01.438-.437h1.687a.4.4 0 01.396.333l.27 1.459a.747.747 0 01-.005.265.427.427 0 01-.12.214l-1 1.02c.292.5.657.97 1.094 1.407.438.437.92.816 1.448 1.135l.98-.979a.677.677 0 01.542-.167l1.437.292c.097.021.177.068.24.141a.38.38 0 01.093.255v1.688a.424.424 0 01-.438.437z"
			/>
		</svg>
	);
}

export default ContactHRIcon;
